export const actionTypes = {
  REQUEST_START: 'TAPS.APPEAL.CATEGORY.THEMES.REQUEST_START',
  REQUEST_SUCCESS: 'TAPS.APPEAL.CATEGORY.THEMES.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'TAPS.APPEAL.CATEGORY.THEMES.REQUEST_FAILURE',
};

export function startRequest(categoryCode) {
  return {
    type: actionTypes.REQUEST_START,
    payload: categoryCode,
  };
}

export function requestSuccess(data, categoryCode) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: { data, categoryCode },
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
